import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../../axiosInstance";
import { constantsApiEndpoints } from "../../../api";
import { toast } from "sonner";

// State that the response will be put into
const initialState = {
  countries: null,
  isLoading: false,
  success: false,
  error: null,
};

// Async API call with Axios timeout
export const fetchCountriesList = createAsyncThunk(
  "fetchCountriesList",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("Post countries");
      const response = await Axios.post(`${constantsApiEndpoints.countries}`, null, {
        timeout: 30000, // Set timeout to 30 seconds
      });
      return response.data;
    } catch (error) {
      if (error.code == 'ECONNABORTED') {
        // Handle timeout specific error
        return rejectWithValue('Request timed out');
      }
      // If countries endpoint doesn't exist, fall back to static data
      if (error.response?.status === 404) {
        console.log("Countries endpoint not available, using static data");
        return rejectWithValue('Countries endpoint not available');
      }
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);

// Redux slice that contains the reducers/action calls
export const countriesListSlice = createSlice({
  name: "Get Countries List",
  initialState,
  reducers: {
    clearCountriesListError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // FETCH COUNTRIES API
    builder.addCase(fetchCountriesList.pending, (state, action) => {
      console.log("Pending", state.success)
      if (!state.data) {
        state.isLoading = true;
        state.success = false;
      }
    });
    builder.addCase(fetchCountriesList.fulfilled, (state, action) => {
      state.success = true;
      console.log("Fulfilled", state.success)
      state.isLoading = false;
      state.error = null;
      state.countries = action.payload;
    });
    builder.addCase(fetchCountriesList.rejected, (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.error = action.payload;
    });
  },
});

// SELECTORS which can be easily called to get the corresponding value
export const selectCountries = (store) => store.countriesList?.countries
export const selectCountriesLoader = (store) => store?.countriesList?.isLoading
export const selectCountriesSuccess = (store) => store?.countriesList?.success
export const selectCountriesError = (store) => store?.countriesList?.error

// ACTIONS TO DISPATCH
export const { clearCountriesListError } = countriesListSlice.actions;

export default countriesListSlice.reducer;